/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import {
  getToken,
  wxConfig
} from '../utils/auth'
import axiosRoute from '../utils/axios'

import Register from '@/components/register'
import Login from '@/components/login'
import Index from '@/components/Index'
import List from '@/components/list'
import SubList from '@/components/sub-list'
import Special from '@/components/special'
import More from '@/components/more'
import SpecialDetail from '@/components/special-detail'
import Event from '@/components/event'
import SearchList from '@/components/search-list'

import User from '@/components/user'
import UserMsg from '@/components/user-msg'
import IndustryReport from '@/components/industry-report'
import IndustryReportDetail from '@/components/industry-report-detail'
import Result from '@/components/result'
// 404
import Err404 from '@/components/404'

import Detailnotice from '@/components/detailnotice'
import Bottom from '@/components/bottom'
import Singup from '@/components/singup'
import SingupSuccess from '@/components/singupSuccess'
import Agenda from '@/components/Agenda'
import Applicant from '@/components/applicant'
import Msg from '@/components/msg'
import Share from '@/components/share'
import Questionnaire from '@/components/questionnaire'
import Signin from '@/components/signin'
import DinnerSignin from '@/components/dinnerSignin'
import Signincode from '@/components/signinCode'
import Signinsuccess from '@/components/signinSuccess'
import Signinfail from '@/components/signinfail'
import signInMeal from '@/components/signInMeal'
import VipServiceAgreement from '@/components/VipServiceAgreement'
import weeklyDetail from '@/components/weeklyDetail'

Vue.use(Router)

const routes = [{
  path: '/404',
  component: Err404,
  hidden: true
},
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index')
    // component: Index
  },
  {
    path: '/list',
    name: 'list',
    component: List
  },
  {
    path: '/sub-list',
    name: 'sub-list',
    component: SubList
  },
  {
    path: '/special',
    name: 'special',
    component: Special
  },
  {
    path: '/more',
    name: 'more',
    component: More
  },
  {
    path: '/special-detail',
    name: 'special-detail',
    component: SpecialDetail
  },
  {
    path: '/vip/report',
    redirect: '/industry-report',
    hidden: true
  },
  {
    path: '/event',
    name: 'event',
    component: Event
  },
  {
    path: '/search-list',
    name: 'search-list',
    component: SearchList
  },
  {
    path: '/user',
    name: 'user',
    component: User
  },
  {
    path: '/user-msg',
    name: 'user-msg',
    component: UserMsg
  },
  {
    path: '/industry-report',
    name: 'industry-report',
    component: IndustryReport
  },
  {
    path: '/industry-report-detail',
    name: 'industry-report-detail',
    component: IndustryReportDetail
  },
  {
    path: '/result',
    name: 'result',
    component: Result
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  },
  {
    path: '/detail/:contentId/:categoryId/:parentId',
    name: 'detail',
    component: () => import('@/views/detail'),
    props: true
  },

  {
    path: '/detailnotice',
    name: 'detailnotice',
    component: Detailnotice,
    props: true
  },
  {
    path: '/bottom/:index',
    name: 'bottom',
    component: Bottom,
    props: true
  },
  {
    path: '/singup',
    name: 'singup',
    component: Singup,
  },
  {
    path: '/detail/singupSuccess',
    name: 'singupSuccess',
    component: SingupSuccess,
  },
  {
    path: '/applicant',
    name: 'applicant',
    component: Applicant,
  },
  {
    path: '/msg',
    name: 'msg',
    component: Msg,
  },
  {
    path: '/share',
    name: 'share',
    component: Share,
  },
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: Questionnaire,
  },
  {
    path: '/detail/signIn',
    name: 'signin',
    component: Signin,
  },
  {
    path: '/detail/dinnerSignin/:contentId',
    name: 'dinnerSignin',
    component: DinnerSignin,
  },
  {
    path: '/detail/signinCode',
    name: 'signinCode',
    component: Signincode,
  },
  {
    path: '/detail/agenda',
    name: 'agenda',
    component: Agenda,
  },
  {
    path: '/detail/signinSuccess',
    name: 'signinSuccess',
    component: Signinsuccess,
  },
  {
    path: '/detail/signinFail',
    name: 'signinFail',
    component: Signinfail,
  },
  {
    path: '/detail/signInMeal',
    name: 'signInMeal',
    component: Signin,
  },
  {
    path: '/vipServiceAgreement',
    name: 'vipServiceAgreement',
    component: VipServiceAgreement,
  },
  {
    path: '/weeklyDetail/:weeklyId',
    name: 'weeklyDetail',
    component: weeklyDetail,
    props: true
  }
]
const vueRouter = new Router({
  mode: 'history',
  routes: routes
})

vueRouter.beforeEach((to, from, next) => {
  vueRouter.from = from.path
  // console.log('rrrr', vueRouter)
  if (to.name == 'user' || to.name == 'industry-report') {
    console.log(from.name)
    // 未登录过
    if (!getToken()) {
      next({
        path: '/login',
        query: {
          from: to.name
        }
      })
    }
  }
  next()

})
export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js